// extracted by mini-css-extract-plugin
module.exports = {"tagline_container":"styles_tagline_container__OGqQM","badge":"styles_badge__Y9kU2"};